// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a883199d","732":"63163067","977":"30c0146c"}[chunkId] + ".chunk.js";
};